import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  translate,
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  ShowButton,
  EditButton,
  Pagination,
} from "react-admin";
import Chip from "@material-ui/core/Chip";
import TemplateTypes from "../../config/TemplateTypes";
import resources from "../../config/resources";
import { getKey } from "../../lib/i18nUtils";
import TemplateFilters from "./TemplateFilters";
import paginationOptions from "../../config/PaginationOptions";

const styles = () => ({
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    float: "right",
  },
});

const TypeField = translate(({ record, translate }) => (
  <span>
    {record && record.type && TemplateTypes.hasOwnProperty(record.type) ? (
      <Chip label={translate(TemplateTypes[record.type].translation)} />
    ) : null}
  </span>
));

const Actions = ({ basePath, displayedFilters, filters, filterValues, resource, showFilter }) => (
  <TopToolbar>
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <CreateButton basePath={basePath} />
  </TopToolbar>
);

const TemplatesList = ({ translate, classes, ...props }) => (
  <List
    {...props}
    actions={<Actions />}
    bulkActionButtons={false}
    filters={<TemplateFilters />}
    pagination={<Pagination {...paginationOptions} />}
  >
    <Datagrid>
      <TextField source="__id" sortBy="id" label={translate(getKey("id", resources.TEMPLATES))} />
      <TextField source="name" />
      <TypeField label={translate(getKey("type", resources.TEMPLATES))} />
      <TextField source="subject" />
      <EditButton className={classes.actionButton} />
      <ShowButton className={classes.actionButton} />
    </Datagrid>
  </List>
);

TypeField.propTypes = {
  record: PropTypes.object,
  translate: PropTypes.func,
};

Actions.propTypes = {
  basePath: PropTypes.string,
  displayedFilters: PropTypes.object,
  filters: PropTypes.object,
  filterValues: PropTypes.object,
  resource: PropTypes.string,
  showFilter: PropTypes.func,
};

TemplatesList.propTypes = {
  classes: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
};

export default withStyles(styles)(translate(TemplatesList));
